import * as React from 'react';
import { ISearchSuggestionItem } from 'PyzShopUi/scripts/search-suggestion/interfaces';

interface IPlainLayoutProps {
    suggestions: ISearchSuggestionItem[];
    isLoading: boolean;
    isVisible: boolean;
    isSmallScreen: boolean;

    onClose(): void;
}

const PlainLayout: React.FunctionComponent<React.PropsWithChildren<IPlainLayoutProps>> = props => {
    const {suggestions, isLoading, isVisible, isSmallScreen, children, onClose} = props;

    const headerHeight = React.useMemo(() => {
        const headerElement = document.querySelector('header');

        return headerElement ? headerElement.offsetHeight : 0;
    }, [isSmallScreen]);

    if (!isVisible) {
        return null;
    }

    const displayResultBoard = () => {
        if (!suggestions.length || isLoading) {
            return null;
        }

        return (
            <div className="plain-suggest-result__result-board">
                {children}
            </div>
        );
    };

    const backgroundStyle = {
        top: `${headerHeight}px`,
    };

    if (isSmallScreen) {
        backgroundStyle['backgroundColor'] = 'transparent';
    }

    return (
        <div className="relative-container grid-container">
            <div onClick={onClose} style={backgroundStyle} className="plain-suggest-result__background"/>
            <div className="plain-suggest-result grid-x grid-margin-x">
                <div onClick={onClose} className="cell large-2"/>
                <div className="cell auto">
                    {displayResultBoard()}
                </div>
                <div onClick={onClose} className="cell large-3"/>
            </div>
        </div>
    );
};

export default PlainLayout;
